import { FC } from "react";
import { FormTitle, FormWrapper } from "./components/MonolithFormComponents";
import { useSnackbar, VariantType } from "notistack";
import LoggingAPI from "@/api/logging";
import { usePermissions } from "@/hooks/usePermissions";

import { nanoid } from "nanoid";
import UserRolesAPI from "@/api/UserRoles/UserRoles";
import { DefaultUserRoleForm } from "@/components/Forms";

interface CreateUserRoleFormProps {
  width?: number | undefined;
  onSubmit: () => void; // Refetch query from parent component
  onCancel: () => void;
  buttonProps?: { cancelText?: string; submitText?: string };
}

export const CreateUserRoleForm: FC<CreateUserRoleFormProps> = ({
  width,
  onSubmit,
  onCancel,
}) => {
  const { currentUser } = usePermissions();
  const { enqueueSnackbar } = useSnackbar();

  const handleSubmit = async (data: any) => {
    try {
      const uuid = nanoid();
      await UserRolesAPI.create({
        ...data,
        created_on: new Date().toISOString(),
        created_by_id: currentUser?.uuid || currentUser?.user_id,
        uuid: uuid,
      });

      onSubmit?.();
      enqueueSnackbar(`${data?.name || ""} role created`, {
        variant: "success" as VariantType,
      });

      LoggingAPI.createLog({
        user_id: currentUser.user_id,
        message: `Created user role.`,
        event: "user_role:create",
        object_type: "user_role",
        object_uuid: uuid,
      });
    } catch (error) {
      console.error(error);
      enqueueSnackbar(
        "An error occurred while creating this User Role. Please try again.",
        { variant: "error" as VariantType }
      );
    }
  };

  return (
    <FormWrapper width={width}>
      <DefaultUserRoleForm
        onSubmit={handleSubmit}
        onCancel={onCancel}
        buttonProps={{ submitText: "Create Role" }}
      />
    </FormWrapper>
  );
};
